import React, { createContext, useEffect } from "react";

interface Toast {
    message: string,
    type: 'success' | 'error' | 'info' | 'warning'
}

interface ToastContext {
    toast: (toast: Toast) => void
    toastError: (message: string) => void
    toastSuccess: (message: string) => void
}

const toastContext = createContext<ToastContext>({
    toast: () => { },
    toastError: () => { },
    toastSuccess: () => { },
})

export const useToast = () => React.useContext(toastContext);

interface Props {
    children: React.ReactNode
}

export const ToastContextProvider = (props: Props) => {
    const [state, setState] = React.useState<Toast>({
        message: '',
        type: 'info',
    });


    useEffect(() => {
        if (state.message) {
            const timeout = setTimeout(() => {
                setState(oldState => ({ ...oldState, message: '' }))
            }, 2000);

            return () => {
                clearTimeout(timeout);
            }
        }
    }, [state.message, setState])

    return <toastContext.Provider value={{
        toast: setState,
        toastError: (message: string) => setState({ message, type: 'error' }),
        toastSuccess: (message: string) => setState({ message, type: 'success' }),
    }}>
        <div style={{ maxHeight: state.message ? 100 : 0 }} className="overflow-hidden toast-container">
            <div className={`toast toast-${state.type}`}>{state.message || ' '}</div>
        </div>
        {props.children}
    </toastContext.Provider>
}
